import { BEIGE_500, GRAY_700, GRAY_900 } from 'constants/styling/upbrandingTheme'
import { Box, Stack, Typography } from '@mui/material'

import { AnalyticsEvent } from 'utils/analytics'
import { FC } from 'react'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import { MUIBadge } from 'components/common/MUIBadge'
import { MUIButton } from 'components/common/MUIButton'
import { SimpleImage } from 'components/common/SimpleImage'
import ai_studio_upsell from 'assets/img/self-editing/ai_studio_upsell.webp'
import { externalNavigate } from 'utils/helpers'
import { getPricingUrl } from 'utils/localization'
import i18n from 'translations/i18n'
import { useClientAIStudio } from './ClientAIStudio.context'
import { useTranslation } from 'react-i18next'

/**
 * Upsell component for non-subscribers in AI Studio
 * Displays a promotional section encouraging users to subscribe to access AI tools
 * @example <NonSubscribersUpsell logAIStudioEvent={logAIStudioEvent} />
 */
export const NonSubscribersUpsell: FC = () => {
  const { t } = useTranslation(['ai_studio_editing', 'common'])
  const { logAIStudioEvent } = useClientAIStudio()

  const handleSubscribeClick = () => {
    logAIStudioEvent(AnalyticsEvent.PINTURA_UPSELL_NON_SUBSCRIBER_BUTTON)
    externalNavigate(getPricingUrl(i18n.language))
  }

  return (
    <Box
      sx={{ backgroundColor: BEIGE_500, margin: 1.2, borderRadius: '.8rem', height: 'fit-content' }}
    >
      <Stack sx={{ padding: 1.2 }}>

        <MUIBadge
          size="xs"
          color="coral"
          icon={<LockOutlinedIcon fontSize="small" />}
          label={t('common:Subscribers_only')}
          sx={{ marginBottom: 1.2, width: 'fit-content' }}
        />
        <Typography variant="text-sm" fontWeight="600" color={GRAY_900}>
          {t('non_subscribers_title')}
        </Typography>
        <Typography variant="text-xs" fontWeight="400" color={GRAY_700} marginTop={0.6}>
          {t('non_subscribers_description')}
        </Typography>

        <MUIButton
          sx={{ marginTop: 1, marginBottom: 1.6, fontSize: '12px', width: 'fit-content' }}
          size="sm"
          onClick={handleSubscribeClick}
        >
          {t('subscribe_to_bkbn_button')}
        </MUIButton>

        <SimpleImage
          key="non-subscribers-ai-studio-promo"
          url={ai_studio_upsell}
          sx={{
            width: '100%',
            height: '100%',
            maxWidth: '25.6rem',
            maxHeight: '55.4rem',
          }}
          borderRadius="none"
        />

      </Stack>
    </Box>
  )
} 
